import React from 'react';
import '../App.css';

const Footer = () => {
  return (
    <footer className="footer py-2 "> 
      <div className="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
        {/* Left Section */}
        <div className="d-flex align-items-center mb-2 mb-md-0">
          <small>© {new Date().getFullYear()} FTTHSA. All rights reserved.</small>
        </div>

        {/* Middle Section */}
        <div className="d-flex align-items-center mb-2 mb-md-0 text-white"> {/* Added text-white */}
          <a href="/help" className="footer-link me-3 text-white">Help & Support</a> {/* Added text-white */}
          <div className="social-icons d-flex align-items-center">
            <a href="https://www.facebook.com/profile.php?id=100077963720140" className="footer-icon me-2 text-white"><i className="fab fa-facebook-f"></i></a> {/* Added text-white */}
            <a href="https://www.instagram.com/ftthsa/" className="footer-icon me-2 text-white"><i className="fab fa-instagram"></i></a> {/* Added text-white */}
            <a href="https://wa.me/27605486408" target="_blank" rel="noopener noreferrer" className="footer-icon text-white" aria-label="Chat on WhatsApp"><i className="fab fa-whatsapp"></i></a> {/* Added text-white */}
          </div>
        </div>

        {/* Right Section */}
        <div className="d-flex align-items-center text-white"> {/* Added text-white */}
          <a href="/Terms" className="footer-link me-2 text-white">* T's & C's</a> {/* Added text-white */}
          <a href="/Privacy" className="footer-link text-white">Privacy Policy</a> {/* Added text-white */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
